// extracted by mini-css-extract-plugin
export var deleteModal = "_qc-0";